import { __assign } from "tslib";
import React from 'react';
import { getCleanUserHtmlWithMetadata } from '../utils/cleanUserHtml';
export var SecureUserHtml = React.memo(function (_a) {
    var html = _a.html, containerProps = _a.containerProps;
    var cleanHtml = getCleanUserHtmlWithMetadata(html).html;
    return (React.createElement("div", __assign({}, containerProps, { dangerouslySetInnerHTML: { __html: cleanHtml } })));
});
//# sourceMappingURL=SecureUserHtml.js.map